export default theme => ({
  container: {
    margin: 0
  }
});